import { render, staticRenderFns } from "./vEtapaSeleccion.vue?vue&type=template&id=2ca68684&scoped=true&"
import script from "./vEtapaSeleccion.vue?vue&type=script&lang=js&"
export * from "./vEtapaSeleccion.vue?vue&type=script&lang=js&"
import style0 from "./vEtapaSeleccion.vue?vue&type=style&index=0&id=2ca68684&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ca68684",
  null
  
)

export default component.exports